export default "__VITE_ASSET__7715798e__"